import { render } from "./User-profil.vue?vue&type=template&id=5a723a99"
import script from "./User-profil.vue?vue&type=script&lang=js"
export * from "./User-profil.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__